module.exports = {"titleModalSuccess":"Tudo certo!","bodyModalSuccess":"Sua data de vencimento foi alterada com sucesso!","titleModalError":"Ops! Algo deu errado","bodyModalError":"Não foi possível alterar sua data de vencimento. Verifique os dados fornecidos e tente novamente"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/EditDueDate/data.json
// module id = 2147
// module chunks = 0